export default "__VITE_ASSET__CGCSRz_y__"